import PropTypes from 'prop-types'

const BackgroundGlyph = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="1315"
    height="1046"
    viewBox="0 0 1315 1046"
  >
    <defs>
      <linearGradient
        id="observian-google-background-glyph-b"
        x1="12.453%"
        x2="87.895%"
        y1="84.924%"
        y2="16.33%"
      >
        <stop offset="0%" stopColor="#1D8DBA" />
        <stop offset="100%" stopColor="#03ECAE" />
      </linearGradient>
      <circle id="observian-google-background-glyph-a" cx="616.61" cy="522.5" r="522.5" />
      <mask
        id="observian-google-background-glyph-c"
        width="1045"
        height="1045"
        x="0"
        y="0"
        fill="#fff"
      >
        <use xlinkHref="#observian-google-background-glyph-a" />
      </mask>
      <linearGradient
        id="observian-google-background-glyph-d"
        x1="18.96%"
        x2="81.329%"
        y1="84.924%"
        y2="16.33%"
      >
        <stop offset="0%" stopColor="#1D8DBA" />
        <stop offset="100%" stopColor="#03ECAE" />
      </linearGradient>
      <linearGradient
        id="observian-google-background-glyph-e"
        x1="12.453%"
        x2="87.895%"
        y1="55.929%"
        y2="44.284%"
      >
        <stop offset="0%" stopColor="#1D8DBA" />
        <stop offset="100%" stopColor="#03ECAE" />
      </linearGradient>
      <linearGradient
        id="observian-google-background-glyph-f"
        x1="12.453%"
        x2="87.895%"
        y1="54.575%"
        y2="45.589%"
      >
        <stop offset="0%" stopColor="#1D8DBA" />
        <stop offset="100%" stopColor="#03ECAE" />
      </linearGradient>
      <linearGradient
        id="observian-google-background-glyph-g"
        x1="20.23%"
        x2="80.047%"
        y1="84.924%"
        y2="16.33%"
      >
        <stop offset="0%" stopColor="#FCBB00" />
        <stop offset="98.375%" stopColor="#F1BC24" />
        <stop offset="100%" stopColor="#FFC671" />
      </linearGradient>
      <linearGradient
        id="observian-google-background-glyph-h"
        x1="65.07%"
        x2="42.764%"
        y1="8.229%"
        y2="38.975%"
      >
        <stop offset="0%" stopColor="#5ED488" />
        <stop offset="100%" stopColor="#30A950" />
      </linearGradient>
      <linearGradient
        id="observian-google-background-glyph-i"
        x1="16.003%"
        x2="47.352%"
        y1="75.969%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#3065BB" />
        <stop offset="100%" stopColor="#5A99FF" />
      </linearGradient>
      <linearGradient
        id="observian-google-background-glyph-j"
        x1="20.23%"
        x2="80.047%"
        y1="84.924%"
        y2="16.33%"
      >
        <stop offset="0%" stopColor="#EC3E2B" />
        <stop offset="100%" stopColor="#F94E3C" />
      </linearGradient>
      <linearGradient
        id="observian-google-background-glyph-k"
        x1="12.453%"
        x2="87.895%"
        y1="53.731%"
        y2="46.403%"
      >
        <stop offset="0%" stopColor="#EC3E2B" />
        <stop offset="100%" stopColor="#F94E3C" />
      </linearGradient>
      <linearGradient
        id="observian-google-background-glyph-l"
        x1="7.122%"
        x2="46.66%"
        y1="51.952%"
        y2="53.758%"
      >
        <stop offset="0%" stopColor="#3065BB" />
        <stop offset="100%" stopColor="#5A99FF" />
      </linearGradient>
      <linearGradient
        id="observian-google-background-glyph-m"
        x1="12.453%"
        x2="87.895%"
        y1="55.49%"
        y2="44.707%"
      >
        <stop offset="0%" stopColor="#FCBB00" />
        <stop offset="98.375%" stopColor="#F1BC24" />
        <stop offset="100%" stopColor="#FFC671" />
      </linearGradient>
      <linearGradient
        id="observian-google-background-glyph-n"
        x1="69.006%"
        x2="40.874%"
        y1="36.297%"
        y2="46.383%"
      >
        <stop offset="0%" stopColor="#5ED488" />
        <stop offset="100%" stopColor="#30A950" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        stroke="url(#observian-google-background-glyph-b)"
        strokeDasharray="55 75"
        strokeLinejoin="round"
        strokeWidth="150"
        d="M616.610412,809.717285 C797.879813,809.717285 944.827697,662.769401 944.827697,481.5 C944.827697,300.230599 797.879813,153.282715 616.610412,153.282715 C435.34101,153.282715 288.393126,300.230599 288.393126,481.5 C288.393126,662.769401 435.34101,809.717285 616.610412,809.717285 Z"
        opacity=".037"
      />
      <g
        stroke="url(#observian-google-background-glyph-b)"
        strokeDasharray="25 255"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity=".037"
      >
        <use
          strokeWidth="10"
          mask="url(#observian-google-background-glyph-c)"
          xlinkHref="#observian-google-background-glyph-a"
        />
        <use xlinkHref="#observian-google-background-glyph-a" />
      </g>
      <path
        fill="url(#observian-google-background-glyph-d)"
        fillRule="nonzero"
        d="M669.559069,451.995095 L669.559069,497.227223 C669.564889,501.18412 667.456236,504.842633 664.029457,506.821079 L617.857297,533.501399 C614.435569,535.476935 610.219825,535.476935 606.798097,533.501399 L560.625937,506.821079 C557.199158,504.842633 555.090505,501.18412 555.096138,497.227223 L555.096138,451.995095 C555.08365,450.86276 555.679381,449.810648 556.656907,449.238995 C557.634434,448.667342 558.843493,448.664021 559.824145,449.230295 L608.152849,477.154775 C609.42251,477.891911 610.859767,478.291678 612.327697,478.315991 C613.804463,478.318988 615.255252,477.927657 616.530193,477.182423 L664.858897,449.257943 C665.833497,448.708302 667.02644,448.716557 667.99334,449.279634 C668.96024,449.84271 669.556139,450.876193 669.559069,451.995095 Z M568.865041,429.489623 L606.798097,407.620055 C610.219825,405.64452 614.435569,405.64452 617.857297,407.620055 L655.735057,429.489623 C656.745368,430.042624 657.373596,431.102669 657.373596,432.254423 C657.373596,433.406177 656.745368,434.466223 655.735057,435.019223 L612.327697,460.013015 L568.865041,434.936279 C567.895948,434.371636 567.299921,433.334541 567.299921,432.212951 C567.299921,431.091362 567.895948,430.054267 568.865041,429.489623 Z M615.866641,353.319383 L699.142417,401.371607 C710.005393,407.643331 716.689837,419.240946 716.671249,431.784407 L716.671249,511.963607 C716.689837,524.507068 710.005393,536.104684 699.142417,542.376407 L629.828881,582.134231 C618.973448,588.401619 605.599002,588.401619 594.743569,582.134231 L525.457681,542.127575 C514.594705,535.855852 507.910262,524.258236 507.928849,511.714775 L507.928849,416.025047 C507.931421,413.442897 506.548875,411.057743 504.306961,409.776599 L504.306961,409.776599 C502.06957,408.484821 499.313532,408.482446 497.073917,409.770366 C494.834303,411.058287 493.45015,413.441535 493.441297,416.025047 L493.441297,511.770071 C493.468976,529.492988 502.956048,545.852916 518.324497,554.679767 L587.444497,594.686423 C602.775367,603.531125 621.658843,603.531125 636.989713,594.686423 L706.330897,554.679767 C721.703521,545.857109 731.192131,529.494529 731.214097,511.770071 L731.214097,431.729111 C731.14666,414.016946 721.670268,397.675434 706.330897,388.819415 L623.165713,340.767191 C620.925778,339.487072 618.174041,339.494911 615.941436,340.787771 C613.708831,342.080632 612.332353,344.463366 612.327697,347.043287 L612.327697,347.043287 C612.320981,349.626549 613.690476,352.017897 615.921937,353.319383 L615.866641,353.319383 Z M545.474833,517.824983 C541.074705,515.277986 538.366474,510.5781 538.369297,505.493975 L538.369297,436.567511 C538.359193,431.488673 541.070703,426.793646 545.474833,424.264151 L605.277457,389.565911 C609.672845,387.021631 615.093142,387.021631 619.488529,389.565911 L679.291153,424.153559 C683.72129,426.711109 686.43505,431.452269 686.396689,436.567511 L686.396689,508.839383 C686.401367,511.426813 687.780639,513.816848 690.018577,515.115479 L690.018577,515.115479 C692.256889,516.350046 694.97906,516.318636 697.18829,515.032751 C699.39752,513.746866 700.769293,511.395391 700.8013,508.839383 L700.8013,436.567511 C700.806121,426.305482 695.336312,416.820264 686.451985,411.684311 L626.732305,377.096663 C617.849874,371.981526 606.916112,371.981526 598.033681,377.096663 L538.231057,411.684311 C529.336089,416.813237 523.854082,426.299779 523.854082,436.567511 L523.854082,505.687511 C523.843563,515.951067 529.314902,525.438936 538.203409,530.570711 L601.517329,566.900183 C603.755481,568.166302 606.497104,568.150963 608.720949,566.859882 C610.944794,565.5688 612.317485,563.195522 612.327697,560.624087 L612.327697,560.624087 C612.328698,558.035134 610.947908,555.642468 608.705809,554.347991 L545.474833,517.824983 Z"
        opacity=".068"
      />
      <polygon
        fill="url(#observian-google-background-glyph-e)"
        points="11.576 422.915 36.801 478.97 78.858 434.289 161.256 417.298"
        opacity=".141"
      />
      <polygon
        fill="url(#observian-google-background-glyph-f)"
        points="1186.076 454.866 1310.668 506.549 1328.864 457.179 1265.946 476.16"
        opacity=".141"
        transform="rotate(-40 1257.47 480.707)"
      />
      <g opacity=".86">
        <g opacity=".252" transform="translate(0 347.499)">
          <polygon
            fill="url(#observian-google-background-glyph-g)"
            points="52.768 17 59.015 25.639 44.768 33"
          />
          <polygon
            fill="url(#observian-google-background-glyph-h)"
            points="6.25 197.098 9.569 201.688 2 205.598"
            transform="rotate(41 5.784 201.348)"
          />
          <polygon
            fill="url(#observian-google-background-glyph-i)"
            points="1204.389 43.709 1210.636 52.348 1196.389 59.709"
            transform="rotate(148 1203.513 51.709)"
          />
          <polygon
            fill="url(#observian-google-background-glyph-j)"
            points="1152.101 236.709 1155.42 241.298 1147.851 245.209"
            transform="rotate(41 1151.636 240.959)"
          />
          <polygon
            fill="url(#observian-google-background-glyph-k)"
            points="270.154 13.342 270.154 20.076 287.379 13.342 306.632 8.153"
            transform="rotate(26 288.393 14.115)"
          />
          <polygon
            fill="url(#observian-google-background-glyph-l)"
            points="204.256 196.638 205.303 204.071 217.544 206.579 240.518 201.608 217.544 201.608"
          />
          <polygon
            fill="url(#observian-google-background-glyph-m)"
            points="1002.838 205.122 1015.92 207.552 1023.389 199.404"
          />
          <polygon
            fill="url(#observian-google-background-glyph-n)"
            points="977.389 35.644 1002.838 23.686 1019.583 21.547 1015.026 11.478"
          />
        </g>
      </g>
    </g>
  </svg>
)

BackgroundGlyph.defaultProps = {
  className: '',
}

BackgroundGlyph.propTypes = {
  className: PropTypes.string,
}

export default BackgroundGlyph
